import styles from "./AffiliateProgram.module.css";
import NavigationTop from "../../components/NavigationTop/NavigationTop";
import ContributionForm from "../../components/ContributionForm/ContributionForm";
import MiniTopContributors from "../../components/MiniTopContributors/MiniTopContributors";
import ContacUs from "../../components/ContacUs/ContacUs";
import Modal from "../../components/Modal/Modal";
import { Helmet } from "react-helmet-async";
import { useState } from "react";

const AffiliateProgram = () => {
  const [showContactModal, setShowContactModal] = useState(false);

  const handleCloseModal = () => {
    setShowContactModal(false);
  };

  return (
    <>
      <Helmet>
        <title>Distortion Grids Database – Affiliate Program</title>
        <meta
          name="description"
          content="Join the community of Lens Distortion Contributors & Earn rewards! 15% discount promo code for any purchase in the Distortion Grids Database."
        />
        <meta property="og:title" content="Distortion Grids Database – Affiliate Program" />
        <meta
          property="og:description"
          content="Join the community of Lens Distortion Contributors & Earn rewards! 15% discount promo code for any purchase in the Distortion Grids Database."
        />
      </Helmet>

      <NavigationTop title="Affiliate program" />

      <section className={`height ${styles.main}`}>
        <div className={styles.container}>
          <div className={`h4-medium ${styles.textCont}`}>
            <p>
              <span>Join the community of Lens Distortion Contributors!</span>
            </p>
            <p>
              <span>Shape the future.</span> Let's build the most comprehensive
              Distortion Grids Database. Your shared distortion grids will make
              this resource even more valuable for the entire community.
            </p>
            <p>
              <span>Become a Contributor & Earn rewards.</span> Everyone who
              uploads distortion grids and gets them approved by our team
              becomes a valued contributor. You'll receive a{" "}
              <span>A 15% discount for single purchase</span> in the Distortion
              Grids Database as a gratitude for your contribution. Top contributors,
              those who consistently share high-quality assets, will be recognized
              on a dedicated page, showcasing their work to a wider audience.
            </p>
            <p>
              <span>Let's push the boundaries of CG together!</span> Share your
              assets and contribute to this ever-growing resource. The more
              distortion grids we have, the more options artists will have to
              bring their visions to life. Upload your grids today and become
              part of a thriving creative community!
            </p>
            <p>
              If you want to upload a large volume of assets,{" "}
              <a
                href="#"
                className={styles.emailLink}
                onClick={(e) => {
                  e.preventDefault();
                  setShowContactModal(true);
                }}
              >
                email us
              </a>{" "}
              and we'll suggest a convenient upload method.
            </p>
          </div>

          <ContributionForm />
        </div>

        <MiniTopContributors />
      </section>

      <Modal isOpen={showContactModal} onClose={handleCloseModal}>
        <ContacUs />
      </Modal>
    </>
  );
};

export default AffiliateProgram;